import styled from 'styled-components';
import Slider from 'react-input-slider';

export const Container = styled.div`
`;

export const StyledSlider = styled(Slider)`
  height: 150px !important; //altura do mixer (individual)
  width: 11px !important;
  border-radius: 0px !important;
  background: ${(props) => props.theme.simulation.sliderThumbBackgroundColor} !important;
  >[class*="-Slider"]{
    border-radius: 0px !important;
    width: 11px !important;
  }
`;
